import {
  getApprovalMasterKey,
  getApprovalMastersKey,
  useGetApprovalMaster,
  useUpdateApprovalMaster,
} from 'api-hooks/approval-master';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { SeparatorVertical } from 'components/styles';
import { DetailContainer } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import { NavigationProps } from 'types';

import ApprovalMasterForm from './components/form';

export type ApprovalMasterViewParams = { id: string };
export default function ApprovalMasterView(
  props: NavigationProps<NavigationRoutes.ApprovalMastersView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetApprovalMaster({
    id,
  });

  const { mutateAsync, error: errorMutate } = useUpdateApprovalMaster();

  const approval = data?.data;
  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <ApprovalMasterForm
            {...props}
            approval={approval}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                approvalId: approval!.id,
              });

              queryClient.refetchQueries([getApprovalMastersKey()[0]]);
              queryClient.refetchQueries(
                getApprovalMasterKey({ id: result.data.id }),
              );
              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
